import { useLocation } from "react-router-dom";
import Seo from "@/components/Seo";

const DEFAULT_META = {
  title: "AnySkill - Student Skills Marketplace",
  description:
    "AnySkill connects students with local clients so they can offer their skills, earn income, and build a portfolio before graduation.",
};

const ROUTE_META: Record<string, { title: string; description: string }> = {
  "/": DEFAULT_META,
  "/services": {
    title: "Browse Student Services | AnySkill",
    description:
      "Browse every service offered by students on AnySkill, from web development and tutoring to design, photography and errands.",
  },
  "/discover-services": {
    title: "Discover Services Near You | AnySkill",
    description:
      "Search and filter student services by category, price and location to find the right person for your project.",
  },
  "/offer-service": {
    title: "Offer Your Skills as a Student | AnySkill",
    description:
      "List a service on AnySkill in minutes, set your own rate and availability, and start earning from skills you already have.",
  },
  "/requests": {
    title: "Open Service Requests | AnySkill",
    description:
      "See what clients in your community need help with and respond to open service requests posted on AnySkill.",
  },
  "/how-to-start": {
    title: "How to Start Earning on AnySkill",
    description:
      "A step-by-step guide for students: create a profile, define your services, get verified and land your first paid project.",
  },
  "/how-to-hire": {
    title: "How to Hire a Student on AnySkill",
    description:
      "Learn how to browse providers, discuss your project, pay securely and review the work when hiring a student on AnySkill.",
  },
  "/success-stories": {
    title: "Success Stories | AnySkill",
    description:
      "Read how students and clients have worked together on AnySkill and what came out of those projects.",
  },
  "/safety-guidelines": {
    title: "Safety Guidelines & Community Standards | AnySkill",
    description:
      "Our community values, safety rules and reporting tools that keep students and clients protected on AnySkill.",
  },
  "/terms-of-service": {
    title: "Terms of Service | AnySkill",
    description:
      "The terms and user agreement that govern your use of the AnySkill platform, payments and services.",
  },
  "/privacy-policy": {
    title: "Privacy Policy | AnySkill",
    description:
      "How AnySkill collects, uses, stores and protects your personal data, and the choices you have over it.",
  },
  "/help/tax-faq": {
    title: "Tax FAQ for Student Providers | AnySkill",
    description:
      "Common questions about taxes, 1099 forms and record keeping for students earning income through AnySkill.",
  },
  "/manifesto": {
    title: "The AnySkill Manifesto",
    description:
      "Why we're building a launchpad economy: students as founders of their own time, hiring locally, and investing in your own backyard.",
  },
  "/vocab-lab": {
    title: "Vocabulary Lab | AnySkill",
    description:
      "Short daily vocabulary exercises for students: word drills and grouping practice to sharpen language skills.",
  },
  "/vocab-lab/word-drill": {
    title: "Word Drill Exercise | AnySkill Vocabulary Lab",
    description:
      "A daily five-letter word drill that builds spelling, deduction and vocabulary skills in a few minutes.",
  },
  "/vocab-lab/group-sort": {
    title: "Group Sort Exercise | AnySkill Vocabulary Lab",
    description:
      "Sort sixteen words into four related groups to practise semantic reasoning and category recognition.",
  },
};

const RouteSeo = () => {
  const { pathname } = useLocation();
  const normalized =
    pathname.length > 1 && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
  const meta = ROUTE_META[normalized];

  if (!meta) return null;

  return <Seo title={meta.title} description={meta.description} path={normalized} />;
};

export default RouteSeo;